export class DataHandler {
  private dataId: string;
  private runtimeDataCopy: any;

  constructor(dataId: string, defaultData: any) {
    this.dataId = dataId;
    this.runtimeDataCopy = defaultData;
  }

  public save(data: any) {
    this.runtimeDataCopy = data;
    if (!this.isLocalStorageAvailable()) return;

    window.localStorage.setItem(this.dataId, JSON.stringify(data));
  }

  public load(): any {
    if (!this.isLocalStorageAvailable()) {
      // Return fake or local data.
      return this.runtimeDataCopy;
    }

    let data = window.localStorage.getItem(this.dataId);
    // TODO: Check if data is an object.
    if (data) data = JSON.parse(data);

    return data ?? this.runtimeDataCopy;
  }

  protected isLocalStorageAvailable(): boolean {
    let testData = '0ed4bef58f9f4832adfd264671fb7e8c';

    try {
      window.localStorage.setItem(testData, testData);
      window.localStorage.removeItem(testData);
      return true;
    } catch (error) {
      return false;
    }
  }
}
